import {SERVER_URL, REST_API_URL, STD_HEADERS, FORMDATA_HEADERS, TEST_HEADER} from '../settings/base';
// import {REST_API_URL as url} from "../settings/production";

const checkTestUrl = REST_API_URL + "test/" + "check_test/";
const itemView = REST_API_URL + "viewed_items/add/";
const examResult = REST_API_URL + "set_problem_result/";
const feedbackUrl = REST_API_URL + 'add_bug_report/';
const submissionUrl = REST_API_URL + 'student/submission/';
const animationView = REST_API_URL + 'viewed_items/add_viewed_animation/';

export const postTestResults = (data, everyone) => {
    if (everyone) {
        STD_HEADERS.Authorization = 'CgjhbvZHeccrbqT,fkDfcDHjn';
    }
    return fetch(
        checkTestUrl,
        {
            method: "POST",
            headers: STD_HEADERS,
            body: JSON.stringify(data)
        }
    )
};

export const postFeedback = data => (
    fetch(feedbackUrl, {
        method: "POST",
        headers: STD_HEADERS,
        body: JSON.stringify(data)
    })
);

export const postExamResult = data => (
    fetch(examResult,
        {
            method: "POST",
            headers: STD_HEADERS,
            body: JSON.stringify(data)
        })
);

export const postItemView = (data) => (
    fetch(
        itemView,
        {
            method: "POST",
            headers: STD_HEADERS,
            body: JSON.stringify(data)
        }
    )
);

export const postStudentSubmission = (data) => (
    fetch(
        submissionUrl,
        {
            method: "POST",
            headers: FORMDATA_HEADERS,
            body: data
        }
    )
);

export const postAnimationView = (data) => (
    fetch(
        animationView,
        {
            method: "POST",
            headers: STD_HEADERS,
            body: JSON.stringify(data)
        }
    )
);


// WEBPACK FOOTER //
// ./src/api/post_apis.js